import { SendMultiChannel, NavJourneys24, NavLists24 } from 'ui/icons';
import { colors } from 'ui/theme';
import { ResourceType } from '../../types';

export const ResourceIcon = ({ resourceType }: { resourceType: ResourceType | string }) => {
  switch (resourceType) {
    case ResourceType.Journey:
      return <NavJourneys24 color={colors.grey25} data-test={`${resourceType}_icon`} />;
    case ResourceType.List:
      return <NavLists24 color={colors.grey25} data-test={`${resourceType}_icon`} />;
    default:
      return <SendMultiChannel color={colors.grey25} data-test={`MultiChannel_icon`} />;
  }
};
